import type { ReactElement } from 'react';

import { useLayoutDirection } from '../../hooks/useDirection.js';

export interface DirectionalIconProps {
  /**
   * The icon element. In RTL mode, it is mirrored horizontally via CSS transform
   * so chevrons / arrows / undo/redo glyphs point the right way.
   */
  children: ReactElement;
  /** Set true for icons that should NOT flip in RTL (e.g. logos, time, charts). */
  noFlip?: boolean;
  className?: string;
}

export function DirectionalIcon({ children, noFlip, className }: DirectionalIconProps): JSX.Element {
  const dir = useLayoutDirection();
  const flip = !noFlip && dir === 'rtl';
  const cls = [
    'inline-flex',
    flip ? 'scale-x-[-1]' : '',
    className ?? '',
  ]
    .filter(Boolean)
    .join(' ');
  return <span aria-hidden="true" className={cls}>{children}</span>;
}
